import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';

/**
 * Global loading interceptor — shows the app-wide loading bar whenever any
 * HTTP request is in flight, so every page gets automatic loading feedback
 * without each component having to manage its own spinner.
 *
 * Requests can opt out by adding the header `X-Skip-Loader: 1` (used for
 * silent/background polling that shouldn't flash the bar).
 */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loading = inject(LoadingService);

  if (req.headers.has('X-Skip-Loader')) {
    // strip the marker header and pass through without touching the loader
    const clean = req.clone({ headers: req.headers.delete('X-Skip-Loader') });
    return next(clean);
  }

  loading.start();
  return next(req).pipe(finalize(() => loading.stop()));
};